import { useEffect, useState } from 'react';

interface StaggeredAnimationConfig {
  baseDelay?: number;
  cardDuration?: number;
  lineDuration?: number;
}

export function useStaggeredAnimation(itemCount: number, config?: StaggeredAnimationConfig) {
  const { baseDelay = 150, cardDuration = 300, lineDuration = 150 } = config ?? {};

  const [visibleIndices, setVisibleIndices] = useState<number[]>([]);
  const [visibleLineIndices, setVisibleLineIndices] = useState<number[]>([]);

  useEffect(() => {
    const timers: NodeJS.Timeout[] = [];

    for (let i = 0; i < itemCount; i++) {
      const cardDelay = baseDelay + i * (cardDuration + lineDuration);

      timers.push(setTimeout(() => setVisibleIndices(prev => [...prev, i]), cardDelay));

      if (i < itemCount - 1) {
        timers.push(
          setTimeout(() => setVisibleLineIndices(prev => [...prev, i]), cardDelay + cardDuration),
        );
      }
    }

    return () => timers.forEach(timer => clearTimeout(timer));
  }, [itemCount, baseDelay, cardDuration, lineDuration]);

  return { visibleIndices, visibleLineIndices };
}
